// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hotList":"hotList-9uL8HnnT","play_btn":"play_btn-3i2nCSFh","title":"title-1kQRvCbf"};